import { render, staticRenderFns } from "./GiftListSlider.vue?vue&type=template&id=8b49e826"
import script from "./GiftListSlider.vue?vue&type=script&lang=js"
export * from "./GiftListSlider.vue?vue&type=script&lang=js"
import style0 from "./GiftListSlider.vue?vue&type=style&index=0&id=8b49e826&prod&global=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports